<template>
  <div class="my-info-box">
    <div class="info-box">
      <van-image width="60" @click="goLogin" height="60" round :src="user.avatar" />
      <span class="username" @click="goLogin">{{ user.name }}</span>
      <!-- <van-button size="small" @click="clearMe">Clear me</van-button> -->
    </div>
    <div class="action-box">
      <van-cell-group>
        <van-cell
          v-for="menu in menus"
          title-class="menu-title"
          :to="menu.to"
          :key="menu.name"
          is-link
          center
          :title="menu.title"
        >
          <template #icon>
            <img :src="menu.icon" width="20px" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import coinPng from "@/assets/images/coin.png";
import walletPng from "@/assets/images/wallet.png";
import historyPng from "@/assets/images/history.png";
import Avatar from "@/assets/images/user.png";

export default {
  data() {
    this.menus = [
      { name: "store", title: "Recharge Store", icon: coinPng, to: "me/recharge-store" },
      { name: "history", title: "Recharge History", icon: walletPng, to: "me/recharge-history" },
      { name: "views", title: "Reading Views", icon: historyPng, to: { name: "history" } }
    ];
    return {};
  },
  computed: {
    user() {
      const user = this.$store.state.user;
      if (user && user.name) {
        return user;
      }
      return {
        name: "Log in",
        avatar: Avatar
      };
    }
  },
  methods: {
    goLogin() {
      if (!this.user.user_id) {
        this.$router.push({ name: "login" });
      }
    },
    // use to clear webview's cache
    clearMe() {
      localStorage.setItem("user", "{}");
    }
  },
  mounted() {
    if (window.location.search) {
      window.location.search = "";
    }
    window.$event("Mine_Page_Show", {});
  }
};
</script>

<style lang="scss" scoped>
.my-info-box {
  .info-box {
    padding: 16px;
    display: flex;
    align-items: center;
    background: linear-gradient(180deg, #f4efff, #ffffff);
    height: 20vh;
    .username {
      font-size: $fs-xxl;
      font-weight: 500;
      margin-left: 16px;
    }
  }
  .action-box {
    .menu-title {
      margin-left: 20px;
      padding-bottom: 6px;
      padding-top: 6px;
      font-size: $fs-main;
    }
  }
}
</style>
